import Success from 'components/alerts/Success';
import { TextArea } from 'components/common/form/modules/input/TextArea';
import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { emailBlast } from 'components/graphql/queries'
import { closeModal } from 'components/modal/modules/dispatcher/methods';
import React, { useCallback, useState } from 'react'
import { connect } from 'react-redux';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from 'reactstrap'
import UserDucks from 'stores/ducks/User.duck';
import { FacebookShareButton, PinterestShareButton, RedditShareButton, TelegramShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share'

const EmailsModal: React.FC<{ [label: string]: any }> = (props: any) => {

    const [loading, setLoading] = useState(false)

    const [campaignId] = useState(props.campaignId)
    const [message, setMessage] = useState('')
    const [sendEmailTo, setSendEmailTo] = useState('Customers (This Campaign)')
    const [emailType, setEmailType] = useState('Message')
    const [customEmails, setCustomEmails] = useState('')

    const [success, setSuccess] = useState(false)
    const [successMesssage, setSuccessMessage] = useState('')
    const [shareVia, setShareVia] = useState('E-mail')

    const sendEmails = useCallback(() => {

        setLoading(true)
        setSuccess(false)
        setSuccessMessage('')

        if (emailType === 'Message' && (!message || message === '')) {
            alert('Message is required')
            setLoading(false)
            return
        }

        if ((sendEmailTo === 'Custom Emails' || sendEmailTo === 'Custom Phone Numbers') && (!customEmails || customEmails === '')) {
            alert(shareVia === 'SMS' ? 'Enter phone numbers' : 'Enter custom emails')
            setLoading(false)
            return
        }

        // send email to
        // email type
        // has two new options for the SMS

        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: emailBlast,
                variables: {
                    campaignId,
                    sendTo: sendEmailTo,
                    emailType,
                    customEmails: customEmails.toLowerCase().split("\n"),
                    message: message.split("\n"),
                    shareVia
                }
            })
            .then(res => {
                if (res.data.data.campaign.emailBlast) {
                    setSuccess(true)
                    if (shareVia === 'SMS') {
                        alert('Phone numbers have been sent')
                    } else {
                        alert('Emails have been sent')
                    }
                    setLoading(false)
                } else {
                    alert('Something went wrong, try')
                    setLoading(false)
                }
            })
            .catch((err) => {
                alert('Something went wrong, try')
                setLoading(false)
            })

    }, [emailType, sendEmailTo, shareVia, campaignId, customEmails, message, setSuccess, setSuccessMessage])

    let salesLink = (props.user.isAdmin || props.createdBy === props.user.id) ?
        'https://' + props.subdomain + '.isotopeticketing.com' :
        'https://' + props.subdomain + '.isotopeticketing.com' + '/' + props.user.username

    const url = window.location.href.toLowerCase();
    const urlItems = url.split('/')
    const subdomain = urlItems[2].split('.')[0]
    // if (subdomain === 'localhost:3000') {
    //     salesLink = (props.user.isAdmin || props.createdBy === props.user.id) ?
    //         ('http://localhost:3000/sell/' + props.subdomain) :
    //         ('http://localhost:3000/sell/' + props.subdomain + '/' + props.user.username)
    // } else
    if (subdomain === 'test') {
        salesLink = (props.user.isAdmin || props.createdBy === props.user.id) ?
            ('https://test.isotopeticketing.com/sell/' + props.subdomain) :
            ('https://test.isotopeticketing.com/sell/' + props.subdomain + '/' + props.user.username)
    }

    console.log(salesLink)

    return <div style={{ padding: '20px' }}>
        <div style={{ textAlign: 'left' }}>
            <div style={{ flexDirection: screen.width < 768 ? 'column' : 'row', display: 'flex' }}>
                <div style={{ width: screen.width < 768 ? '100%' : '30%' }}>
                    <p style={{ float: 'left', width: '100%', flexDirection: 'row', display: 'flex' }}>
                        <span>Share via &nbsp;&nbsp;</span>
                        <span>
                            <UncontrolledDropdown>
                                <DropdownToggle
                                    caret={true}
                                    className='new-button-cancel'
                                    data-toggle="dropdown"
                                    tag='button'
                                    style={{ paddingLeft: '0px', width: 'auto' }}
                                >
                                    {props.canBroadcast ? shareVia : 'Social Media'}
                                </DropdownToggle>
                                <DropdownMenu>
                                    {
                                        props.canBroadcast ? <>
                                            <DropdownItem header={true}>
                                                Broadcast message
                                            </DropdownItem>
                                            <DropdownItem onClick={() => {
                                                setShareVia('E-mail')
                                                setMessage('')
                                                setEmailType('Message')
                                                setSendEmailTo('Customers (This Campaign)')
                                                setCustomEmails('')
                                            }}>
                                                E-mail
                                            </DropdownItem>
                                            <DropdownItem onClick={() => {
                                                // alert("SMS marketing launching soon!")
                                                // setIsSMS(true)
                                                setShareVia('SMS')
                                                setMessage('')
                                                setEmailType('Message')
                                                setSendEmailTo('Customers (This Campaign)')
                                                setCustomEmails('')
                                            }}>
                                                SMS
                                            </DropdownItem>
                                        </> : null
                                    }
                                    <DropdownItem header={true}>
                                        Share flyer via social media
                                    </DropdownItem>
                                    <DropdownItem onClick={() => {
                                        // alert("Facebook marketing launching soon!")
                                        setShareVia('Facebook')
                                    }}>
                                        Facebook
                                    </DropdownItem>
                                    <DropdownItem onClick={() => {
                                        setShareVia('Whatsapp')
                                    }}>
                                        Whatsapp
                                    </DropdownItem>
                                    <DropdownItem onClick={() => {
                                        setShareVia('Twitter')
                                    }}>
                                        Twitter
                                    </DropdownItem>
                                    <DropdownItem onClick={() => {
                                        setShareVia('Reddit')
                                    }}>
                                        Reddit
                                    </DropdownItem>
                                    <DropdownItem onClick={() => {
                                        setShareVia('Pinterest')
                                    }}>
                                        Pinterest
                                    </DropdownItem>
                                    <DropdownItem onClick={() => {
                                        setShareVia('Telegram')
                                    }}>
                                        Telegram
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </span>
                    </p>
                    <br />
                    <br />
                </div>
                {
                    shareVia === 'E-mail' || shareVia === 'SMS' ?
                        <div style={{ width: screen.width < 768 ? '100%' : '30%' }}>
                            <p style={{ float: 'left', width: '100%', flexDirection: 'row', display: 'flex' }}>
                                <span>Share &nbsp;&nbsp;</span>
                                <span>
                                    <UncontrolledDropdown>
                                        <DropdownToggle
                                            caret={true}
                                            className='new-button-cancel'
                                            data-toggle="dropdown"
                                            tag='button'
                                            style={{ paddingLeft: '0px', width: 'auto' }}
                                        >
                                            {emailType}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {
                                                shareVia === 'SMS' ?
                                                    <DropdownItem onClick={() => setEmailType('Your Primary Link')}>
                                                        Your Primary Link
                                                    </DropdownItem>
                                                    : <DropdownItem onClick={() => setEmailType('Flyer')}>
                                                        Flyer
                                                    </DropdownItem>
                                            }
                                            <DropdownItem onClick={() => setEmailType('Message')}>
                                                Message
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </span>
                            </p>
                            <br />
                            <br />
                        </div> : null
                }
                {
                    shareVia === 'E-mail' || shareVia === 'SMS' ?
                        <div style={{ width: screen.width < 768 ? '100%' : '39%' }}>
                            <p style={{ float: 'left', width: '100%', flexDirection: 'row', display: 'flex' }}>
                                <span>Share with &nbsp;&nbsp;</span>
                                <span>
                                    <UncontrolledDropdown>
                                        <DropdownToggle
                                            caret={true}
                                            className='new-button-cancel'
                                            data-toggle="dropdown"
                                            tag='button'
                                            style={{ paddingLeft: '0px', width: 'auto' }}
                                        >
                                            {' ' + sendEmailTo}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {
                                                shareVia === 'E-mail' ?
                                                    <DropdownItem onClick={() => setSendEmailTo('Affiliates')}>
                                                        All Team Members
                                                    </DropdownItem> : null
                                            }
                                            <DropdownItem onClick={() => setSendEmailTo('Customers (This Campaign)')}>
                                                Customers (This Event)
                                            </DropdownItem>
                                            <DropdownItem onClick={() => setSendEmailTo('Customers (Other Campaigns)')}>
                                                Customers (Other Events)
                                            </DropdownItem>
                                            <DropdownItem onClick={() => setSendEmailTo('All Customers (All Your Campaigns)')}>
                                                Customers (All Events)
                                            </DropdownItem>
                                            {
                                                shareVia === 'E-mail' ?
                                                    <DropdownItem onClick={() => setSendEmailTo('Custom Emails')}>
                                                        Custom Emails
                                                    </DropdownItem> :
                                                    <DropdownItem onClick={() => setSendEmailTo('Custom Phone Numbers')}>
                                                        Custom Phone Numbers
                                                    </DropdownItem>
                                            }
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </span>
                            </p>
                            <br />
                            <br />
                        </div> : null
                }
            </div>
            {
                (shareVia === 'E-mail' || shareVia === 'SMS') &&
                    (sendEmailTo === 'Custom Emails' || sendEmailTo === 'Custom Phone Numbers') ?
                    <div style={{ paddingTop: '35px' }}>
                        <TextArea
                            label={shareVia === 'E-mail' ? 'Enter Emails' : 'Enter Phone Numbers'}
                            value={customEmails}
                            onChange={e => {
                                setCustomEmails(e.target.value)
                                setSuccess(false)
                                setSuccessMessage('')
                            }}
                            placeholder={
                                shareVia === 'E-mail'
                                    ? 'One email per line. Emails will only be sent to valid email IDs. Multiple entries permitted.'
                                    : 'One phone number per line. Phone numbers will only be sent to valid email IDs. Multiple entries permitted.'}
                        />
                    </div> : null
            }
            {
                emailType === 'Message' && (shareVia === 'E-mail' || shareVia === 'SMS') ?
                    <div style={{ marginTop: '15px' }}>
                        <TextArea
                            value={message}
                            onChange={e => {
                                if (shareVia === 'SMS') {
                                    if (e.target.value.length > 150) {
                                        setMessage(e.target.value.substring(0, 150))
                                    } else {
                                        setMessage(e.target.value)
                                    }
                                } else {
                                    setMessage(e.target.value)
                                }
                                setSuccess(false)
                                setSuccessMessage('')
                            }}
                            placeholder={'Enter Message'}
                            infoMessage={
                                shareVia === 'SMS' ? ((150 - message.length).toString() + ' characters left') : 'Campaign information and your sales link will be included in emails along with your message.'
                            }
                        />
                    </div> : null
            }
            {/* {
                error ?
                    <div style={{ padding: '20px', paddingBottom: '0px' }}>
                        <Error content={errorMessage} />
                    </div>
                    : null
            } */}
            {
                success ?
                    <div style={{ padding: '20px', paddingBottom: '0px' }}>
                        <Success content={successMesssage} />
                    </div>
                    : null
            }
        </div>
        <div style={{ width: '100%', textAlign: 'center', paddingTop: '25px' }}>
            {
                shareVia === 'E-mail' || shareVia === 'SMS' ?
                    (<button className='new-button-save' onClick={() => {
                        if (success) {
                            closeModal()
                        } else {
                            sendEmails()
                        }
                    }}>
                        {
                            (loading ? 'SHARING...' : 'SHARE')
                        }
                    </button>) : (
                        shareVia === 'Facebook' ?
                            <FacebookShareButton
                                translate=''
                                url={salesLink}
                                title='Event Invite'
                                children={<button className='new-button-save' onClick={() => {
                                    console.log('')
                                }}>
                                    SHARE
                                </button>}
                            /> : (
                                shareVia === 'Whatsapp' ?
                                    <WhatsappShareButton
                                        translate=''
                                        url={salesLink}
                                        title='Event Invite'
                                        children={<button className='new-button-save' onClick={() => {
                                            console.log('')
                                        }}>
                                            SHARE
                                        </button>}
                                    /> : (
                                        shareVia === 'Twitter' ?
                                            <TwitterShareButton
                                                translate=''
                                                url={salesLink}
                                                title='Event Invite'
                                                children={<button className='new-button-save' onClick={() => {
                                                    console.log('')
                                                }}>
                                                    SHARE
                                                </button>}
                                            />
                                            : (
                                                shareVia === 'Reddit' ?
                                                    <RedditShareButton translate=''
                                                        url={salesLink}
                                                        title='Event Invite'
                                                        children={<button className='new-button-save' onClick={() => {
                                                            console.log('')
                                                        }}>
                                                            SHARE
                                                        </button>}
                                                    />
                                                    : (
                                                        shareVia === 'Pinterest' ?
                                                            <PinterestShareButton translate=''
                                                                media={'https://www.isotopeticketing.com'}
                                                                url={salesLink}
                                                                title='Event Invite'
                                                                children={<button className='new-button-save' onClick={() => {
                                                                    console.log('')
                                                                }}>
                                                                    SHARE
                                                                </button>}
                                                            />
                                                            : (
                                                                shareVia === 'Telegram' ?
                                                                    <TelegramShareButton translate=''
                                                                        url={salesLink}
                                                                        title='Event Invite'
                                                                        children={<button className='new-button-save' onClick={() => {
                                                                            console.log('')
                                                                        }}>
                                                                            SHARE
                                                                        </button>}
                                                                    />
                                                                    : null
                                                            ))
                                            ))
                            )
                    )
            }
        </div>
        {/* {
            !success ?
                <div style={{ width: '100%', textAlign: 'center', paddingTop: '15px' }}>
                    <button
                        className="new-button-cancel"
                        onClick={e => closeModal()}
                    >
                        CANCEL
                    </button>
                </div> : null
        } */}
    </div >
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(EmailsModal);


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsDashboard/Emails.tsx